export const PublishedJob = {
    Titles: {
        JobPublished: 'Job Published',
        ReviewJobDetails: 'Review Job Details'
    },
    Items: {
        Location: {
            Text: 'Job Location'
        },
        Time: {
            Text: 'Job Time'
        },
        Amount: {
            SecondaryText: 'Price: $'
        }
    },
    SubTitles: {
        Confirm: 'Confirm'
    },
    Buttons: {
        Back: {
            label: 'Back'
        },
        Publish: {
            label: 'Get Bids'
        }
    },
    Paragraphs: {
        Hazardous: 'I affirm my job does not include hazardous materials.'
    }
}



// WEBPACK FOOTER //
// ./src/localization/PublishedJob.ts